import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import api, { apiStatusSlice } from './services/api';
import authSlice, { actions as authActions, selectors as authSelectors } from './auth-slice';
import subscriptionSlice, { actions as subscriptionActions, selectors as subscriptionSelectors } from './subscription-slice';

const authPersistConfig = {
  key: 'auth',
  storage,
}

const notificationPersistConfig = {
  key: 'notifications',
  storage,
}

const subscriptionPersistConfig = {
  key: 'subscription',
  storage,
}

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [apiStatusSlice.name]: apiStatusSlice.reducer,
  [authSlice.name]: persistReducer(authPersistConfig, authSlice.reducer),
  [subscriptionSlice.name]: persistReducer(subscriptionPersistConfig, subscriptionSlice.reducer),
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.mode !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(api.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export const actions = {
  auth: authActions,
  subscription: subscriptionActions,
}

export const selectors = {
  auth: authSelectors,
  subscription: subscriptionSelectors,
}

export const userAPI = api;

export const slices = {
  api: apiStatusSlice,
  auth: authSlice,
  subscription: subscriptionSlice,
}
